import {Component, Inject, OnInit} from '@angular/core';
import {BkashRefundConfirm, BkashRefundConfirmRes} from '../pg-detailed-transaction-report/pg-transaction-view';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {NGXLogger} from 'ngx-logger';
import {ReportingService} from '../reporting.service';
import {LoaderService} from '../../shared/loader/loader.service';
import {CommonDialogNotificationService} from '../../shared/common-dialog-notification/common-dialog-notification.service';
import {Router} from '@angular/router';
import {DialogType} from '../../shared/common-dialog-notification/common.dialog.model';
import {CommonDialogNotificationComponent} from '../../shared/common-dialog-notification/common-dialog-notification.component';

@Component({
  selector: 'app-refund-dialog',
  templateUrl: 'refund-dialog.component.html',
})
export class RefundDialogComponent implements OnInit {

  bkashRefundConfirm: BkashRefundConfirm;
  bkashRefundConfirmRes: BkashRefundConfirmRes;

  constructor(public dialogRef: MatDialogRef<RefundDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private logger: NGXLogger,
              private reportingService: ReportingService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private dialogService: CommonDialogNotificationService,
              private router: Router) {
  }

  ngOnInit() {
    this.bkashRefundConfirm = new BkashRefundConfirm();
    this.bkashRefundConfirmRes = new BkashRefundConfirmRes();
    this.bkashRefundConfirm.bkashTrnxId = this.data.bkashTrnxId;
    this.bkashRefundConfirm.ekpayTrnxId = this.data.ekpayTrnxId;
  }

  onNoClick(): void {
    //this.logger.debug('Bkash Refund confirmation canceled');
    this.dialogRef.close(true);
  }

  bkashRefundConfirmCall(bank_trnx_id: string, ekpay_trnx_id: string) {
    this.loaderService.show();
    this.bkashRefundConfirm.bkashTrnxId = bank_trnx_id.trim();
    this.bkashRefundConfirm.ekpayTrnxId = ekpay_trnx_id.trim();

    this.reportingService.bkashRefundConfirmCall(this.bkashRefundConfirm).subscribe((data) => {
      this.loaderService.hide();
      let notificationDialogRef: MatDialogRef<CommonDialogNotificationComponent>;
      this.bkashRefundConfirmRes = data.body as BkashRefundConfirmRes;
      if (this.bkashRefundConfirmRes.errorCode != null) {
        notificationDialogRef = this.dialogService.open(DialogType.INFO, this.bkashRefundConfirmRes.transactionStatus, 'Refund');
        //this.logger.debug('bkash refund confirmation failed for the transaction ... ', this.bkashRefundConfirmRes);
      } else {
        notificationDialogRef = this.dialogService.open(DialogType.INFO, this.bkashRefundConfirmRes.transactionStatus, 'Refund');
        //this.logger.debug('bkash refund confirmation success for the transaction ... ', this.bkashRefundConfirmRes, 'Refund');
      }
      notificationDialogRef.afterClosed().subscribe(() => {
        this.dialogRef.close(true);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/report/refund-list/refund.dialog.component.ts